import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';

export const getPublishRulesTree = (state: IRootState) => state.publishRules.tree;
export const getPublishRulesActiveTreeItem = (state: IRootState) => state.publishRules.activeTreeItem;
export const getPublishRulesNextActiveTreeItem = (state: IRootState) => state.publishRules.nextActiveTreeItem;
export const getPublishRulesFormRef = (state: IRootState) => state.publishRules?.formRef;
export const getPublishRulesFormData = (state: IRootState) => state.publishRules?.formData;
export const getPublishRulesHistoryChanges = (state: IRootState) => state.publishRules?.historyChanges;
export const getPublishRulesIsNeedSaveAccept = (state: IRootState) => state.publishRules?.isNeedSaveAccept;
export const getPublishRulesErvkKnmReasonTypes = (state: IRootState) =>
  state.publishRules?.formData?.ervkKnmReasonTypes;
